import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { Shield, Eye, EyeOff } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/superbackend`;

export default function SuperLoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { username, password });
      localStorage.setItem('sellmu_super_token', res.data.access_token);
      localStorage.setItem('sellmu_super_user', JSON.stringify(res.data.user));
      toast.success('Login berhasil');
      navigate('/superbackend');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0f172a] flex items-center justify-center p-4" data-testid="super-login-page">
      <div className="w-full max-w-[400px] animate-fade-in">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-[#EB7B44] flex items-center justify-center mx-auto mb-4">
            <Shield size={32} className="text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white" style={{ fontFamily: 'Manrope' }}>Super Admin</h1>
          <p className="text-white/50 mt-1">Sellmu POS Management</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5 bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
          <div className="space-y-2">
            <Label className="text-white/80 font-medium">Username</Label>
            <Input
              value={username} onChange={e => setUsername(e.target.value)} required
              placeholder="username"
              className="h-12 bg-white/10 border-white/20 text-white placeholder:text-white/30 focus:border-[#EB7B44] focus:ring-1 focus:ring-[#EB7B44] rounded-lg"
              data-testid="super-username-input"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-white/80 font-medium">Password</Label>
            <div className="relative">
              <Input
                type={showPw ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} required
                placeholder="********"
                className="h-12 bg-white/10 border-white/20 text-white placeholder:text-white/30 focus:border-[#EB7B44] focus:ring-1 focus:ring-[#EB7B44] rounded-lg pr-12"
                data-testid="super-password-input"
              />
              <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/70">
                {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full h-12 bg-[#EB7B44] hover:bg-[#D96A35] text-white font-semibold rounded-lg" data-testid="super-login-btn">
            {loading ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" /> : 'Login'}
          </Button>
        </form>
      </div>
    </div>
  );
}
